<template>
  <div :key="trigger">
    <validation-observer
      v-if="newProjectData"
      #default="{ handleSubmit }"
      ref="refFormObserver"
    >
      <h4 class="d-flex align-items-center">
        <font-awesome-icon class="mr-50" icon="fa-solid fa-file-lines" />
        <span class="ml-1"
          >{{ newProjectData.id > 0 ? "編輯" : "新增" }}項目</span
        >
      </h4>
      <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-form class="mt-3" @submit.prevent="handleSubmit(onSubmit)">
          <div class="mt-2 mt-sm-3 position-relative">
            <b-row>
              <!-- Project id -->
              <b-col cols="12" md="6">
                <b-form-group
                  label="項目編號："
                  label-for="id"
                  label-cols-md="3"
                  class="align-items-center"
                >
                  <div class="">
                    {{
                      Number(newProjectData.id)
                        ? newProjectData.project_number
                        : "系統自動生成"
                    }}
                  </div>
                </b-form-group>
              </b-col>

              <!-- customer id -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_customer_id"
                >
                  <b-form-group
                    label="客戶："
                    label-for="id"
                    label-cols-md="3"
                    class="required align-items-center"
                  >
                    <v-select
                      id="project_status"
                      v-model="newProjectData.customer_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="customerOptions"
                      label="name_cn"
                      :reduce="(option) => option.id"
                      placeholder="選擇客戶"
                      :filter="customerSearch"
                    >
                      <!-- :disabled="newProjectData.id > 0" -->
                      <template #option="{ name_cn, user_number }">
                        [{{ user_number }}] {{ name_cn }}
                      </template>
                      <template #selected-option="{ name_cn, user_number }">
                        [{{ user_number }}] {{ name_cn }}
                      </template>
                    </v-select>
                    <!-- :clearable="false" -->

                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>
              <!-- invoice_ids -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_invoice_ids"
                >
                  <b-form-group
                    label="發票："
                    label-for="invoice_ids"
                    label-cols-md="3"
                    class="required"
                  >
                    <v-select
                      id="invoice_ids"
                      v-model="newProjectData.invoice_ids"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="
                        invoiceOptions.filter(
                          (ele) => ele.customer_id == newProjectData.customer_id
                        )
                      "
                      :clearable="false"
                      label="invoice_number"
                      :reduce="(option) => option.id"
                      multiple
                      placeholder="請先選擇客戶"
                      :filter="invoiceSearch"
                      @input="onInvoiceChange"
                      :disabled="!newProjectData.customer_id"
                    >
                      <template #option="{ invoice_number, name_cn, address }">
                        [{{ invoice_number }}] {{ name_cn || "未指定客戶"
                        }}{{ address ? " " + address : "" }}
                      </template>
                      <template #selected-option="opt">
                        <span v-if="opt && typeof opt === 'object'">
                          [{{ opt.invoice_number }}]
                          {{ opt.name_cn || '未指定客戶' }}{{ opt.address ? ' ' + opt.address : '' }}
                        </span>
                        <span v-else>
                          {{ formatInvoiceLabelById(opt) }}
                        </span>
                      </template>
                    </v-select>
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <!-- quotation -->
              <!-- <b-col cols="12" md="6">
                 <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_quotation_id"
                >
                  <b-form-group
                    label="報價單："
                    label-for="quotation_id"
                    label-cols-md="3"
                    class="required"
                  >
                    <v-select
                      id="quotation_id"
                      v-model="newProjectData.quotation_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="newQuotationOptions"
                      :clearable="true"
                      label="id"
                      :reduce="(option) => option.id"
                      :placeholder="newProjectData.customer_id ? '選擇報價單' : '請先選擇客戶'"
                      :disabled="!newProjectData.customer_id || newProjectData.id > 0"
                      :filter="quotationSearch"
                      
                    >
                      <template #option="{ quotation_number, name_cn }">
                        {{ quotation_number }} {{ name_cn }}
                      </template>
                      <template
                        #selected-option="{ quotation_number, name_cn }"
                      >
                        {{ quotation_number }} {{ name_cn }}
                      </template>
                    </v-select>

                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col> -->

              <!-- project_status_id -->
              <b-col cols="12" md="6">
                <!-- <validation-provider
                  #default="validationContext"
                  name="狀態"
                  rules="required"
                > -->
                <b-form-group
                  label="項目狀態："
                  label-for="project_status"
                  label-cols-md="3"
                >
                  <!-- class="required" -->
                  <v-select
                    id="project_status"
                    v-model="newProjectData.project_status_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="projectStatusesOptions"
                    :clearable="true"
                    label="name"
                    :reduce="(option) => option.id"
                    placeholder="選擇項目狀態"
                    :filter="projectStatusSearch"
                  >
                  </v-select>

                  <!-- <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback> -->
                </b-form-group>
                <!-- </validation-provider> -->
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- Project name -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_project_name"
                >
                  <b-form-group
                    label="項目名稱："
                    label-for="project_name"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="project_name"
                      v-model="newProjectData.project_name"
                      placeholder="輸入項目名稱"
                      :state="getValidationState(validationContext)"
                    />

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- Project address -->
              <b-col cols="12" md="6">
                <!-- <validation-provider
                  #default="validationContext"
                  name="工程地址"
                  rules="required"
                > -->
                <b-form-group
                  label="工程地址："
                  label-for="address"
                  label-cols-md="3"
                >
                  <!-- class="required" -->
                  <b-form-input
                    id="address"
                    v-model="newProjectData.address"
                    placeholder="輸入工程地址"
                  />
                  <!-- 
                    :state="getValidationState(validationContext)"
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback> -->
                </b-form-group>
                <!-- </validation-provider> -->
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- expect_start_date -->
              <b-col cols="12" md="6">
                <!-- <validation-provider
                  #default="validationContext"
                  name="預定工期"
                  rules="required"
                > -->
                <b-form-group
                  label="預定工期："
                  label-for="expect_start_date"
                  label-cols-md="3"
                >
                  <!-- class="required" -->
                  <flat-pickr
                    v-model="newProjectData.expect_start_date"
                    class="form-control"
                    :config="{
                      allowInput: true,
                      altInput: true,
                      altFormat: 'Y-m-d',
                      dateFormat: 'Y-m-d',
                    }"
                    placeholder="輸入YYYY-MM-DD"
                  />
                  <!-- <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback> -->
                </b-form-group>
                <!-- </validation-provider> -->
              </b-col>

              <!-- expect_end_date -->
              <b-col cols="12" md="6">
                <!-- <validation-provider
                  #default="validationContext"
                  name="完結日期"
                  rules="required"
                > -->
                <b-form-group
                  label="至"
                  label-for="expect_end_date"
                  label-cols-md="3"
                >
                  <!-- class="required" -->
                  <flat-pickr
                    v-model="newProjectData.expect_end_date"
                    class="form-control"
                    :config="{
                      allowInput: true,
                      altInput: true,
                      altFormat: 'Y-m-d',
                      dateFormat: 'Y-m-d',
                    }"
                    placeholder="輸入YYYY-MM-DD"
                  />
                  <!-- <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback> -->
                </b-form-group>
                <!-- </validation-provider> -->
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- project_description -->
              <b-col cols="12" md="12">
                <div
                  class="d-flex flex-wrap flex-md-nowrap align-items-center full_input"
                >
                  <label>服務摘要：</label>
                  <div class="input_wrap">
                    <!-- <validation-provider
                      #default="validationContext"
                      name="服務摘要"
                      rules="required"
                    > -->
                    <b-form-input
                      id="project_description"
                      v-model="newProjectData.project_description"
                      placeholder="輸入服務摘要"
                    />
                    <!--:state="getValidationState(validationContext)"
                       <b-form-invalid-feedback>
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider> -->
                  </div>
                </div>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- customer name cn -->
              <b-col cols="12" md="6">
                <b-form-group
                  label="單據抬頭："
                  label-for="c_name_cn"
                  label-cols-md="3"
                >
                  <b-form-input
                    id="c_name_cn"
                    v-model="newProjectData.name_cn"
                    placeholder="輸入單據抬頭"
                  />
                </b-form-group>
              </b-col>

              <!-- customer name en -->
              <b-col cols="12" md="6">
                <b-form-group
                  label="系統帳號名稱："
                  label-for="c_name"
                  label-cols-md="3"
                >
                  <b-form-input
                    id="c_name"
                    v-model="newProjectData.name"
                    placeholder="輸入系統帳號名稱"
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- customer phone -->
              <b-col cols="12" md="6">
                <b-form-group
                  label="聯絡電話："
                  label-for="c_phone"
                  label-cols-md="3"
                >
                  <b-form-input
                    id="c_phone"
                    v-model="newProjectData.phone"
                    placeholder="輸入聯絡電話"
                  />
                </b-form-group>
              </b-col>

              <!-- customer email -->
              <b-col cols="12" md="6">
                <b-form-group
                  label="電郵地址："
                  label-for="c_email"
                  label-cols-md="3"
                >
                  <b-form-input
                    id="c_email"
                    v-model="newProjectData.email"
                    placeholder="輸入電郵地址"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <hr />

            <b-row>
              <!-- amount -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_amount"
                >
                  <b-form-group
                    label="總金額："
                    label-for="project_amount"
                    label-cols-md="3"
                  >
                    <b-form-input
                      id="project_amount"
                      v-model="newProjectData.amount"
                      placeholder="輸入總金額(請在發票修改)"
                      :disabled="true"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- manager -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  vid="v_manager_id"
                  name="此欄"
                  rules="required"
                >
                  <b-form-group
                    label="工程經理："
                    label-for="payment_method_id"
                    label-cols-md="3"
                    class="required"
                  >
                    <v-select
                      id="manager"
                      v-model="newProjectData.manager_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="userOptions.filter(ele => ele.user_type_id == 1)"
                      :clearable="false"
                      label="name"
                      :reduce="(option) => option.id"
                      placeholder="選擇經理"
                      :filter="userSearch"
                    >
                      <template #option="{ roles, name_cn }">
                        <template v-if="roles && roles[0]">
                          [{{ roles[0].name }}] {{ name_cn }}
                        </template>
                        <template v-else>
                          {{ name_cn }}
                        </template>
                      </template>
                      <template #selected-option="{ roles, name_cn }">
                        <template v-if="roles && roles[0]">
                          [{{ roles[0].name }}] {{ name_cn }}
                        </template>
                        <template v-else>
                          {{ name_cn }}
                        </template>
                      </template>
                    </v-select>

                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- payment_method_id -->
              <!-- <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="付款狀態"
                  rules="required"
                >
                  <b-form-group
                    label="付款狀態："
                    label-for="payment_method_id"
                    label-cols-md="3"
                  >
                    <v-select
                      id="payment_method_id"
                      v-model="newProjectData.payment_method_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="paymentMethodOptions"
                      :clearable="false"
                      label="name"
                      :reduce="(option) => option.id"
                      placeholder="選擇付款狀態"
                    >
                    </v-select>

                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col> -->

              <b-col cols="12">
                <hr />
              </b-col>

              <b-col cols="12" md="6">
                 <validation-provider
                  #default="validationContext"
                  vid="v_manager_id"
                  name="此欄"
                  rules="required"
                >
                <b-form-group
                  label="項目員工："
                  label-for="payment_method_id"
                  label-cols-md="3"
                  class="required"
                >
                  <!-- :options="userOptions.filter(ele => ele.user_type_id == 1 || ele.user_type_id == 3 || ele.user_type_id == 4)" -->
                  <v-select
                    id="manager"
                    v-model="newProjectData.user_ids"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="userOptions"
                    :clearable="false"
                    label="name"
                    :reduce="(option) => option.id"
                    multiple
                    placeholder="選擇員工(可多選)"
                    :filter="userSearch"
                  >
                    <template #option="{ roles, name_cn }">
                      <template v-if="roles && roles[0]">
                        [{{ roles[0].name }}] {{ name_cn }}
                      </template>
                      <template v-else>
                        {{ name_cn }}
                      </template>
                    </template>
                    <template #selected-option="{ roles, name_cn }">
                      <template v-if="roles && roles[0]">
                        [{{ roles[0].name }}] {{ name_cn }}
                      </template>
                      <template v-else>
                        {{ name_cn }}
                      </template>
                    </template>
                  </v-select>
                  <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                </b-form-group>
                </validation-provider>
              </b-col>



              <b-col cols="12">
                <hr />
              </b-col>

              <div v-if="showCostItems">
                <b-row
                  v-for="(cost, index) in newProjectData.cost_items"
                  :key="`cost_${index}`"
                  class="px-1"
                >
                  <b-col
                    cols="12"
                    class="d-flex backgroundColor3 mb-1 radius-round border-1"
                  >
                    <b-row class="flex-grow-1 p-2">
                      <!-- product id -->

                      <b-col cols="12" md="6">
                        <b-row>
                          <b-col cols="12">
                            <b-form-group
                              :label="`商品種類：`"
                              :label-for="`product_category_id${index}`"
                              label-cols-md="2"
                            >
                              <v-select
                                v-model="cost.product_category_id"
                                :dir="
                                  $store.state.appConfig.isRTL ? 'rtl' : 'ltr'
                                "
                                :options="productCategoriesOptions"
                                :clearable="false"
                                label="name"
                                :reduce="(option) => option.id"
                                placeholder="選擇商品種類"
                                disabled
                                readonly
                              >
                              </v-select>
                            </b-form-group>
                          </b-col>
                          <b-col cols="12">
                            <b-form-group
                              :label="`商品(${index + 1})：`"
                              :label-for="`product_id${index}`"
                              label-cols-md="2"
                            >
                              <v-select
                                v-model="cost.product_id"
                                :dir="
                                  $store.state.appConfig.isRTL ? 'rtl' : 'ltr'
                                "
                                :options="productOptions"
                                :clearable="false"
                                label="product_name"
                                :reduce="(option) => option.id"
                                placeholder="選擇商品(請在發票修改)"
                                disabled
                                readonly
                              >
                              </v-select>
                            </b-form-group>
                          </b-col>

                          <b-col cols="12">
                            <b-row class="mb-1 cal-input-group">
                              <!--  -->
                              <b-col md="2" class="label">
                                金額:<span class="colorRed">*</span>
                              </b-col>
                              <b-col md="10" class="c_content">
                                <div
                                  class="content-wrapper d-flex align-items-center"
                                >
                                  <b-input-group
                                    class="group1"
                                    size="md"
                                    :append="getProduct(cost.product_id).unit"
                                  >
                                    <b-form-input
                                      id="cost-quantity"
                                      type="number"
                                      step="any"
                                      v-model="cost.quantity"
                                      placeholder="輸入數量(請在發票修改)"
                                      @input="calTotalCost(cost)"
                                      disabled
                                    />

                                    <!-- @input="(val) => calculatePostponeDate(val)" -->
                                  </b-input-group>

                                  <div class="operator">*</div>

                                  <b-input-group
                                    class="group2"
                                    size="md"
                                    prepend="$"
                                    :append="`每${
                                      getProduct(cost.product_id).unit
                                    }`"
                                  >
                                    <b-form-input
                                      :id="`cost_unit_price${index}`"
                                      v-model="cost.unit_price"
                                      placeholder="輸入單價(請在發票修改)"
                                      @input="calTotalCost(cost)"
                                      disabled
                                    />
                                  </b-input-group>

                                  <div class="operator">=</div>

                                  <b-input-group
                                    class="group3"
                                    size="md"
                                    prepend="$"
                                  >
                                    <b-form-input
                                      id=""
                                      class="cost_amount"
                                      disabled
                                      type="number"
                                      v-model="cost.amount"
                                      placeholder="輸入總金額(請在發票修改)"
                                    />
                                  </b-input-group>
                                </div>
                              </b-col>
                            </b-row>
                          </b-col>
                          <!-- <div
                            class="colorRed mt-1"
                            v-if="
                              !cost.quantity || !cost.unit_price || !cost.amount
                            "
                          >
                            <div class="mr-50" v-if="!cost.quantity">
                              請輸入數量
                            </div>
                            <div class="mr-50" v-if="!cost.unit_price">
                              請輸入單價
                            </div>
                            <div class="mr-50" v-if="!cost.amount">
                              請輸入總金額
                            </div>
                          </div> -->
                        </b-row>
                      </b-col>

                      <b-col cols="12" md="6">
                        <b-row>
                          <!-- item_description -->
                          <b-col cols="12">
                            <!-- <validation-provider
                            #default="validationContext"
                            :vid="`v-cost-item_description${index}`"
                            name="備註"
                            rules="required"
                          > -->
                            <b-form-group
                              label="備註/尺寸："
                              :label-for="`cost-item_description${index}`"
                              label-cols-md="2"
                            >
                              <!-- class="required"
                                :state="getValidationState(validationContext)" -->
                              <b-form-textarea
                                :id="`cost-item_description${index}`"
                                v-model="cost.item_description"
                                rows="4"
                                placeholder="輸入備註/尺寸(請在發票修改)"
                                disabled
                              />
                              <!-- <b-form-invalid-feedback>
                                {{ validationContext.errors[0] }}
                              </b-form-invalid-feedback> -->
                            </b-form-group>
                            <!-- </validation-provider> -->
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col cols="12">
                        <label class="colorRed">內容請在發票修改</label>
                      </b-col>
                    </b-row>
                    <div
                      class="d-flex flex-column justify-content-between py-50 px-25"
                    >
                      <feather-icon
                        size="16"
                        icon="PlusIcon"
                        class="cursor-pointer text-success"
                        @click="addItem('cost_items', index)"
                      />
                      <feather-icon
                        size="16"
                        icon="XIcon"
                        class="cursor-pointer text-danger"
                        @click="removeItem('cost_items', index, cost.id)"
                      />
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-row>
          </div>

          <div class="d-flex mt-1 flex-wrap flex-lg-nowrap justify-content-end">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-sm-2 mobile-w100"
              type="submit"
            >
              <feather-icon size="16" class="mr-1" icon="CheckCircleIcon" />
              提交
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
              class="mt-1 mt-sm-0 mobile-w100"
            >
              取消
            </b-button>
          </div>
        </b-form>
      </b-overlay>
    </validation-observer>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BButton,
  BOverlay,
  BFormTextarea,
  BInputGroup,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { ref, watch } from "@vue/composition-api";
import vSelect from "vue-select";
import store from "@/store";
import router from "@/router";
import Ripple from "vue-ripple-directive";
import "animate.css";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
localize("zh_cn", zh_CN);
import formValidation from "@core/comp-functions/forms/form-validation";
import { required, email } from "@validations";
import { tryOnUnmounted } from "@vueuse/core";

export default {
  data() {
    return {
      required,
    };
  },
  directives: {
    Ripple,
  },
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormFile,
    BFormInvalidFeedback,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BRow,
    BCol,
    BButton,
    BOverlay,
    BFormTextarea,
    BInputGroup,
    flatPickr,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  methods: {
    formatInvoiceLabelById(val) {
      // val 可能是 id 或字串/數字，嘗試轉成 number 後在 options 中查找
      const id = Array.isArray(val) ? (val[0] ? Number(val[0]) : null) : Number(val);
      const opt = this.invoiceOptions && !isNaN(id)
        ? this.invoiceOptions.find(o => o.id === id)
        : null;
      if (opt) {
        return `[${opt.invoice_number}] ${opt.name_cn || '未指定客戶'}${opt.address ? ' ' + opt.address : ''}`;
      }
      // 後備顯示，避免 [[197,116]] 這類錯誤格式
      const raw = Array.isArray(val) ? val.join(',') : val;
      return `[${raw}] 未指定客戶`;
    },
    customerSearch(options, search) {
      var returnOptions = options.filter((item) => {
        return (
          // item.name.toLowerCase().includes(search.toLowerCase()) ||
          item.name_cn.toLowerCase().includes(search.toLowerCase()) ||
          item.user_number.toLowerCase().includes(search.toLowerCase())
        );
      });
      return returnOptions;
    },
    projectStatusSearch(options, search) {
      return options.filter((item) => {
        return item.name.toLowerCase().includes(search.toLowerCase());
      });
    },
    userSearch(options, search) {
      return options.filter((item) => {
        return item.name_cn.toLowerCase().includes(search.toLowerCase());
      });
    },
    onInvoiceChange(event) {
      // event 現在是一個數組（多選）
      if (event && event.length > 0) {
        // 使用第一個選中的發票來填充項目基本資料
        const firstInvoiceId = event[0];
        const selectedInvoice = this.invoiceOptions.find(
          (invoice) => invoice.id === firstInvoiceId
        );

        if (selectedInvoice) {
          // 自動填入項目基本資料（來源為空時保留原值，不要洗掉已填內容）
          const fill = (field, value) => {
            if (value !== null && value !== undefined && value !== "") {
              this.newProjectData[field] = value;
            }
          };
          fill("project_name", selectedInvoice.project_name);
          fill("address", selectedInvoice.address);

          // 自動填入發票的單據抬頭和系統帳號名稱
          fill("name_cn", selectedInvoice.name_cn);
          fill("name", selectedInvoice.name_en || selectedInvoice.name);
        }
      }
    },
    invoiceSearch(options, search) {
      var returnOptions = options.filter((item) => {
        return (
          item.invoice_number.toLowerCase().includes(search.toLowerCase()) ||
          item.name_cn.toLowerCase().includes(search.toLowerCase()) ||
          item.address.toLowerCase().includes(search.toLowerCase())
        );
      });
      return returnOptions;
    },
    quotationSearch(options, search) {
      var returnOptions = options.filter((item) => {
        return (
          item.quotation_number.toLowerCase().includes(search.toLowerCase()) ||
          item.name_cn.toLowerCase().includes(search.toLowerCase())
        );
      });
      return returnOptions;
    },
    addItem(key, index) {
      const newItem = JSON.parse(JSON.stringify({ id: 0 }));
      this.newProjectData[key].splice(index + 1, 0, newItem);
    },
    removeItem(key, index, id) {
      // check number of record
      let record =
        this.newProjectData &&
        this.newProjectData[key] &&
        this.newProjectData[key].length;
      if (record <= 1) {
        this.makeToast("danger", "Warning", "請至少留有一個表單。");
      } else {
        this.newProjectData[key].splice(index, 1);
        this.calTotalAmount();
      }
    },
    hide() {
      this.$router.replace("/projects/list");
    },

    onSubmit() {
      if (
        this.newProjectData.expect_start_date >
        this.newProjectData.expect_end_date
      ) {
        this.$swal({
          text: "預定工期開始日期不何大於終結日期！",
          icon: "error",
          confirmButtonText: "確定",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          showClass: {
            popup: "animate__animated animate__bounceIn",
          },
          buttonsStyling: false,
        });
        return;
      }
      this.$swal({
        title: "你確定嗎?",
        showCancelButton: true,
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;

          this.newProjectData.is_completed = this.newProjectData.project_status_id === 5 ? 1 : 0;
          store
            .dispatch("project/editProject", this.newProjectData)
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.hide();
              //this.$emit("refetch-data");
              // if (this.newProjectData.id == 0) {
              //   this.newProjectData.id = response.data.id;
              //   this.redirect(response.data.id);
              // }
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: JSON.stringify(error.response.data.message),
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    makeToast(variant = null, title = null, content = null) {
      this.$bvToast.toast(content, {
        title: title,
        variant,
        solid: true,
      });
    },
  },
  props: {
    loading: {
      type: Boolean,
      required: true,
      default: false,
    },
    projectData: {
      type: Object,
      required: true,
    },
    projectStatusesOptions: {
      type: Array,
      required: true,
    },
    stageOptions: {
      type: Array,
      required: true,
    },
    paymentMethodOptions: {
      type: Array,
      required: true,
    },
    userOptions: {
      type: Array,
      required: true,
    },
    customerOptions: {
      type: Array,
      required: true,
    },
    quotationOptions: {
      type: Array,
      required: true,
    },
    invoiceOptions: {
      type: Array,
      required: true,
    },
    productCategoriesOptions: {
      type: Array,
      required: true,
    },
    productOptions: {
      type: Array,
      required: true,
    },
    productUnitOptions: {
      type: Array,
      required: true,
    },
  },

  setup(props, { emit }) {
    const newProjectData = ref({ id: 0, cost_items: [{ id: 0 }], invoice_ids: [] });
    const showCostItems = ref(false);
    const trigger = ref(true);
    const triggerCost = ref(true);
    watch(
      () => props.projectData,
      (newVal) => {
        newProjectData.value = {
          ...newVal,
        };
        // 正規化 invoice_ids  d7 (API  d7  bd  b7 ab e1 b5 ad b7 f2 e4 bf a1 JSON  e4 b8 b2 e5 ad 97)
        const rawIds = newProjectData.value.invoice_ids;
        if (typeof rawIds === 'string' && rawIds.trim() !== '') {
          try {
            const parsed = JSON.parse(rawIds);
            newProjectData.value.invoice_ids = Array.isArray(parsed) ? parsed.map((x) => Number(x)) : [];
          } catch (e) {
            //  a1 df bd e2 a5 JSON  e9 8c 80 e8 b6 85,  c2 b7 c5 b0 e7 a9 20 d1 91
            newProjectData.value.invoice_ids = [];
          }
        } else if (typeof rawIds === 'number') {
          newProjectData.value.invoice_ids = [rawIds];
        } else if (!Array.isArray(rawIds)) {
          newProjectData.value.invoice_ids = [];
        }
      }
    );

    // 記錄上一次真正處理過的發票選擇，避免重覆觸發時把使用者已填的欄位洗掉
    const lastHandledInvoiceIds = ref(null);

    watch(
      () => newProjectData.value.invoice_ids,
      (newVal) => {
        const key = JSON.stringify(
          (newVal || []).map((id) => Number(id)).sort((a, b) => a - b)
        );
        if (lastHandledInvoiceIds.value === key) {
          // 發票選擇沒有實際改變，不要重跑自動帶入
          return;
        }
        lastHandledInvoiceIds.value = key;

        // 如果沒有選擇發票，清空相關欄位
        if (!newVal || newVal.length === 0) {
          resetProjectFields();
          return;
        }

        // 使用第一個選中的發票來填充項目基本信息
        const firstInvoiceId = newVal[0];
        const invoiceData = getInvoiceData(firstInvoiceId);

        // 獲取發票數據
        if (!invoiceData) {
          resetProjectFields();
          return;
        }

        // 更新項目基本信息
        updateProjectBasicInfo(invoiceData);

        // 獲取並更新成本項目
        fetchAndUpdateCostItems(firstInvoiceId);

        trigger.value = !trigger.value;
      },
      { deep: true }
    );

    // 輔助函數
    const resetProjectFields = () => {
      newProjectData.value.project_name = null;
      newProjectData.value.address = null;
      newProjectData.value.name_cn = null;
      newProjectData.value.name = null;
      showCostItems.value = false;
    };

    const getInvoiceData = (invoiceId) => {
      return props.invoiceOptions?.find((invoice) => invoice.id === invoiceId);
    };

    // 合計所有選中發票的金額（多發票模式下，總金額不應只取第一張）
    const sumSelectedInvoicesAmount = () => {
      const ids = newProjectData.value.invoice_ids || [];
      return ids.reduce((sum, id) => {
        const inv = getInvoiceData(id);
        return sum + (inv ? Number(inv.total_amount) || 0 : 0);
      }, 0);
    };

    // 只在來源有值時才覆寫，避免把使用者已填好的欄位洗成空白
    const fillIfPresent = (field, value) => {
      if (value !== null && value !== undefined && value !== "") {
        newProjectData.value[field] = value;
      }
    };

    const updateProjectBasicInfo = (invoiceData) => {
      fillIfPresent("project_name", invoiceData.project_name);
      fillIfPresent("address", invoiceData.address);
      // 自動填入發票的單據抬頭和系統帳號名稱
      fillIfPresent("name_cn", invoiceData.name_cn);
      fillIfPresent("name", invoiceData.name_en || invoiceData.name);
    };

    const fetchAndUpdateCostItems = (invoiceId) => {
      store
        .dispatch("project/fetchInvoice", { id: invoiceId })
        .then((response) => {
          const invoice = response.data.invoice;
          if (!invoice) return;

          // 從發票補上聯絡資料（僅限新增項目，且只補「目前仍是空白」的欄位，
          // 不覆寫使用者已經自行填寫的內容）
          if (!Number(newProjectData.value.id)) {
            if (!newProjectData.value.phone) {
              newProjectData.value.phone = invoice.mobile || null;
            }
            if (!newProjectData.value.email) {
              newProjectData.value.email = invoice.email || null;
            }
          }

          newProjectData.value.cost_items = invoice.cost_items.map((item) => ({
            ...item,
            quantity: parseFloat(Number(item.quantity).toString()),
            id: 0,
          }));
          newProjectData.value.amount =
            Math.round(sumSelectedInvoicesAmount() * 10) / 10;
          showCostItems.value = true;
        });
    };

    // 同樣記錄上一次處理過的客戶，避免重覆觸發時洗掉已填欄位
    const lastHandledCustomerId = ref(undefined);

    watch(
      () => newProjectData.value.customer_id,
      (newVal) => {
        if (newProjectData.value.id > 0) {
          return;
        }

        if (lastHandledCustomerId.value === newVal) {
          // 客戶沒有實際改變，不要重跑自動帶入
          return;
        }
        lastHandledCustomerId.value = newVal;

        if (!newVal) {
          newProjectData.value.invoice_ids = [];
          newProjectData.value.project_name = null;
          newProjectData.value.address = null;
          newProjectData.value.name_cn = null;
          newProjectData.value.name = null;
          newProjectData.value.mobile = null;
          newProjectData.value.email = null;
          return;
        }

        console.log(
          "newProjectData.value.customer_id",
          newProjectData.value.customer_id
        );
        if (props.customerOptions && props.customerOptions.length > 0) {
          const customer = props.customerOptions.filter(
            (ele) => ele.id == newVal
          )[0];
          newProjectData.value.invoice_ids = [];
          newProjectData.value.project_name = null;
          newProjectData.value.address = null;
          console.log("customer", customer);
          if (customer) {
            // 自動填入客戶資料
            newProjectData.value.name_cn = customer.name_cn;
            newProjectData.value.name = customer.name;
            newProjectData.value.phone = customer.phone;
            newProjectData.value.email = customer.email;
          }
          trigger.value = !trigger.value;
        }
      }
    );

    const getProduct = (id) => {
      if (id) {
        const obj =
          props.productOptions &&
          props.productOptions.length > 0 &&
          props.productOptions.filter((ele) => ele.id == id)[0];

        if (obj) {
          let product_unit_id = obj.product_unit_id;
          if (product_unit_id) {
            let product_unit = props.productUnitOptions.filter(
              (ele) => ele.id == product_unit_id
            )[0];
            if (product_unit) {
              obj.unit = product_unit.name;
            }
          }
        }
        return { ...{ unit: "次" }, ...obj };
      } else {
        return { unit: "次" };
      }
    };

    const updateSelectedProduct = (_product, _product_id) => {
      let product = getProduct(_product_id);
      _product.quantity = 1;
      _product.unit_price = product.unit_price;
      _product.amount =
        Math.round(
          Number(_product.quantity) * Number(_product.unit_price) * 10
        ) / 10;
      calTotalAmount();
    };

    const calTotalSalary = (item) => {
      if (item.working_days && item.day_salary) {
        item.total_salary =
          Math.round(Number(item.working_days) * Number(item.day_salary) * 10) /
          10;
        calTotalAmount();
      }
    };
    const calTotalCost = (item) => {
      if (item.quantity && item.unit_price) {
        item.amount =
          Math.round(Number(item.quantity) * Number(item.unit_price) * 10) / 10;
        calTotalAmount();
      }
      triggerCost.value = !triggerCost.value;
    };
    const calTotalAmount = () => {
      let total = 0;

      /*     if(newProjectData.value.salary_items && newProjectData.value.salary_items.length > 0){
        total += newProjectData.value.salary_items.reduce(
          (a,b) => 
            a + (Number(b.total_salary) ? Number(b.total_salary) : 0), 0
          )
      } */
      if (
        newProjectData.value.cost_items &&
        newProjectData.value.cost_items.length > 0
      ) {
        total += newProjectData.value.cost_items.reduce(
          (a, b) =>
            a +
            (Number(b.quantity) * Number(b.unit_price)
              ? Number(b.quantity) * Number(b.unit_price)
              : 0),
          0
        );
      }
      newProjectData.value.amount = Math.round(total * 10) / 10;
    };

    const resetProjectData = () => {
      newProjectData.value = JSON.parse(
        JSON.stringify({
          id: 0,
        })
      );
    };

    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetProjectData);

    return {
      refFormObserver,
      getValidationState,
      resetForm,
      newProjectData,
      getProduct,
      calTotalSalary,
      calTotalCost,
      calTotalAmount,
      updateSelectedProduct,
      trigger,
      triggerCost,
      showCostItems,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>

<style lang="scss" scoped>
</style>
